import { styled, Box } from '@mui/material';

type exrtaProps = {
	selected?: boolean;
};

export const CustomTabs = styled(Box)<exrtaProps>((props) => ({
	'& .MuiTabs-root': {
		minHeight: '33px',
		[props.theme.breakpoints.down('sm')]: {
			margin: '0 -24px',
		},
		'& .MuiTabs-indicator': {
			backgroundColor: '#f75d12!important',
		},
		'& .MuiTab-root': {
			color: '#5d777b',
			minHeight: '33px',
			padding: '0 32px 0 20px',
			fontSize: '12px',
			'&:after': {
				position: 'absolute',
				right: '10px',
				width: '20px',
				height: '20px',
				borderRadius: '50%',
				lineHeight: '20px;',
			},
			'&.Mui-selected': {
				color: '#f75d12!important',
			},
		},
	},
	'& .MuiAccordion-root': {
		boxShadow: 'none',
		fontSize: '14px',
		color: '#004751',
		margin: '0 0',
		'&:before': { height: 0 },
		'&.Mui-expanded': { margin: '0 0' },
		'& .MuiAccordionSummary-root': {
			padding: '0 24px',
			margin: '0 -24px',
			borderBottom: '1px solid #004751',
			'&.Mui-expanded': {
				color: '#f75d12',
				minHeight: 'auto',
				borderBottom: '1px solid #f75d12',
				margin: '0 -24px',
				'& .MuiSvgIcon-root': {
					color: '#f75d12',
				},
			},
			'& .MuiAccordionSummary-content': {
				margin: '0 0',
				height: '48px',
				lineHeight: '48px',
				'&.Mui-expanded': {
					color: '#f75d12',
					//borderBottom:'1px solid #f75d12',
					margin: '0 0',
				},
			},
		},
		'& .MuiAccordionDetails-root': {
			padding: '24px 0 24px 0',
		},
	},
}));
